import FormRecover from "../../common/security/FormRecover";

const Recupera = () => {
    return (<>
        <FormRecover/>
    </>)
}
export default Recupera;